import NewRetailCashSales from "../../../../components/@documents/retail_cash_sales/NewRetailCashSales"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailCashSalesNewPage() {

    return (
        <NewRetailCashSales 
            routeType={routeTypes.admin}
        />
    )
}